import moment from "moment";

const isRecord = (value) =>
  value !== null && typeof value === "object" && !Array.isArray(value);

const firstPresent = (...values) =>
  values.find((value) => value !== undefined && value !== null && value !== "") ?? "";

const parseDateTime = (value) => {
  if (!value) return null;

  const parsed = moment(
    value,
    [moment.ISO_8601, "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DDTHH:mm:ss"],
    true,
  );
  return parsed.isValid() ? parsed : null;
};

const formatDate = (value) => {
  if (!value) return "";

  const parsed = moment(
    value,
    ["YYYY-MM-DD", "dddd, DD MMMM YYYY", "dddd, D MMMM YYYY"],
    true,
  );
  return parsed.isValid() ? parsed.format("dddd, DD MMMM YYYY") : "";
};

const formatTime = (value) => {
  if (!value) return "";

  const parsed = moment(value, ["HH:mm:ss", "HH:mm", "h:mma", "hh:mma"], true);
  return parsed.isValid() ? parsed.format("HH:mm") : "";
};

export const getAppointmentEditDefaults = (detail) => {
  const safeDetail = isRecord(detail) ? detail : {};
  const service = isRecord(safeDetail.service) ? safeDetail.service : {};
  const staff = isRecord(safeDetail.staff) ? safeDetail.staff : {};
  const dateTime = parseDateTime(
    firstPresent(safeDetail.showstartdate, safeDetail.start_datetime),
  );

  return {
    service_id: firstPresent(safeDetail.service_id, service.id),
    staff_id: firstPresent(safeDetail.staff_id, staff.id),
    dateof: dateTime
      ? dateTime.format("dddd, DD MMMM YYYY")
      : formatDate(safeDetail.dateof),
    start_time: dateTime
      ? dateTime.format("HH:mm")
      : formatTime(safeDetail.start_time),
  };
};

export const appendCurrentAppointmentOption = (options, value, label) => {
  const safeOptions = Array.isArray(options) ? options : [];
  if (value === undefined || value === null || value === "") {
    return safeOptions;
  }

  const currentValue = String(value);
  if (
    safeOptions.some(
      (option) => isRecord(option) && String(option.value) === currentValue,
    )
  ) {
    return safeOptions;
  }

  // The stored value is authoritative.  When the option list has been filtered
  // down (inactive/unmapped staff) or a display name is unavailable, still
  // append a selectable option so the field is never rendered blank.
  const safeLabel = label === undefined || label === null || String(label).trim() === ""
    ? currentValue
    : label;

  return [...safeOptions, { value, label: safeLabel }];
};
